import '@formatjs/intl-pluralrules/locale-data/de';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-pluralrules/locale-data/it';
import '@formatjs/intl-pluralrules/locale-data/se';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/de';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/locale-data/fr';
import '@formatjs/intl-relativetimeformat/locale-data/it';
import '@formatjs/intl-relativetimeformat/locale-data/se';
import '@formatjs/intl-relativetimeformat/polyfill';

import deMessages from './de.json';
import enMessages from './en.json';
import frMessages from './fr.json';
import itMessages from './it.json';
import seMessages from './se.json';
export const DefaultLocale = 'en';

export interface ILocaleConfig {
  messages: any;
  formats: any;
  locale: string;
}

// Fehlt ein Key in einer Sprache, zeigt react-intl sonst die rohe ID an (DefaultLocale
// greift dafuer nicht). Englisch dient deshalb als Unterlage, die Sprache ueberschreibt.
// Luecken bleiben trotzdem sichtbar: `npm run i18n:check` meldet sie.

export default {
  de: {
    locale: 'de',
    messages: { ...enMessages, ...deMessages },
    formats: {
      number: {
        percentWith2Decimals: { style: 'percent', maximumFractionDigits: 2 },
      },
    },
  },
  en: {
    locale: 'en',
    messages: enMessages,
    formats: {
      number: {
        percentWith2Decimals: { style: 'percent', maximumFractionDigits: 2 },
      },
    },
  },
  fr: {
    locale: 'fr',
    messages: { ...enMessages, ...frMessages },
    formats: {
      number: {
        percentWith2Decimals: { style: 'percent', maximumFractionDigits: 2 },
      },
    },
  },
  it: {
    locale: 'it',
    messages: { ...enMessages, ...itMessages },
    formats: {
      number: {
        percentWith2Decimals: { style: 'percent', maximumFractionDigits: 2 },
      },
    },
  },
  se: {
    locale: 'se',
    messages: { ...enMessages, ...seMessages },
    formats: {
      number: {
        percentWith2Decimals: { style: 'percent', maximumFractionDigits: 2 },
      },
    },
  },
} as { [key: string]: ILocaleConfig };
